import React, { useMemo } from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';
import { useTemplateColors } from 'PDF/TemplateEngine/TemplateColorsContext';
import { formatDate } from 'PDF/TemplateEngine/utils/formatDate';

const formatValue = (raw) => {
  if (raw === null || raw === undefined || raw === '') return '—';
  if (Array.isArray(raw)) return raw.join(', ');
  return String(raw);
};

// Resuelve el texto a mostrar para un campo: si declara `dateFormat` y el valor
// no está vacío, se formatea como fecha; si no, comportamiento de texto actual.
const displayField = (field, raw) =>
  field.dateFormat && raw != null && raw !== ''
    ? formatDate(raw, field.dateFormat)
    : formatValue(raw);

function DataGridSection({ section, data }) {
  const { colors, baseStyles, FONT } = useTemplateColors();
  const styles = useMemo(
    () =>
      StyleSheet.create({
        container: {
          display: 'flex',
          flexDirection: 'column',
        },
        grid: {
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          gap: '0.3cm',
        },
        cell: {
          flexBasis: '48%',
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: colors.lightBg,
          border: `1px solid ${colors.border}`,
          padding: '0.2cm 0.3cm',
        },
        label: {
          fontSize: 8,
          fontFamily: FONT.bold,
          color: colors.primary,
          textTransform: 'uppercase',
          marginBottom: '0.1cm',
        },
        value: {
          fontSize: 10,
          fontFamily: FONT.base,
          color: colors.darkText,
        },
      }),
    [colors, FONT]
  );

  const fields = (section?.config?.fields || []).filter((f) => f.visible !== false);
  if (fields.length === 0) return null;

  return (
    <View style={styles.container} wrap={false}>
      {section?.title ? <Text style={baseStyles.sectionTitle}>{section.title}</Text> : null}
      <View style={styles.grid}>
        {fields.map((field) => (
          <View key={field.key} style={styles.cell}>
            <Text style={styles.label}>{field.label}</Text>
            <Text style={styles.value}>{displayField(field, data?.[field.key])}</Text>
          </View>
        ))}
      </View>
    </View>
  );
}

export default DataGridSection;
